/* eslint-disable no-unused-vars */
// ESLint is showing errors for the DATA_TYPE enum as unused variables in this file

interface BaseFilterSelectedValue {
  values: FilterOptionSelectedValue[];
  matchStrategy?: FilterOptionMatchStrategy;
}
export interface FilterSelectedValue extends BaseFilterSelectedValue {
  id: string;
}
export interface SetFilterSelectedValue extends BaseFilterSelectedValue {
  id: string | undefined;
}

export interface FilterOptionSelectedValue {
  value: any;
  label: string;
  exclude?: boolean;
  metadata?: any;
  disabled?: boolean;
}

export enum OPERATIONS {
  AND = 'and',
  OR = 'or',
}

export enum VALUE_MATCH {
  MULTIPLE = 'multiple',
  EXCLUDE_MULTIPLE = 'exclude_multiple',
  SINGLE = 'single',
  EXCLUDE_SINGLE = 'exclude_single',
  RANGE = 'range',
  GREATER_THAN = '>',
  LOWER_THAN = '<',
  AND = 'AND',
  OR = 'OR',
  SEARCH = 'SEARCH',
}
export interface FilterOptionMatchStrategy {
  operation: OPERATIONS;
  valueMatch: VALUE_MATCH;
  groupName?: string;
  exclude?: boolean;
}
